/**
 * Tiny event bus so the floating support widget (mounted once in App.vue) can
 * be opened from anywhere — an ErrorBoundary, a menu item, a page link. Kept
 * as a plain module (no Pinia store overhead) because the surface is a single
 * event.
 */

const listeners = new Set()

export function onOpenSupportWidget(fn) {
    listeners.add(fn)
    return () => listeners.delete(fn)
}

export function openSupportWidget(payload = {}) {
    for (const fn of listeners) {
        try {
            fn(payload)
        } catch {
            /* keep siblings alive */
        }
    }
}
